// @flow
import Link from './Link'

export default Link
export { default as EmailLink } from './EmailLink'
export { default as PhoneLink } from './PhoneLink'
